/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
import {db} from '../../../../src/firebaseDB'

var SetDesignTab = function (editor) {

    var signals = editor.signals;

    var container = new UI.Panel();
    container.setId('setDesignTab');

    var selected = null;
    var values;


    // Animation editor default values
    var animationEditorIndex = 1
    var defaultAnimationIndex = 0

    function build() {

        container.clear();

        if (selected === null) return;

        values = {};

        // Time

        var row = new UI.Row();
        row.add(new UI.Text('Time').setWidth('45px'));
        container.add(row);

        var animationStart = new UI.Number(selected.start).setWidth('45px');
        animationStart.onChange(function () {

            selected.start = this.getValue();            
            signals.animationModified.dispatch(selected);

        });        
        row.add(animationStart);        
        var animationEnd = new UI.Number(selected.end).setWidth('45px');
        animationEnd.onChange(function () {

            selected.end = this.getValue();
            signals.animationModified.dispatch(selected);

        });
        row.add(animationEnd);

        //Position of origin

        var row = new UI.Row();
        row.add(new UI.Text('Position of origin').setWidth('180px'));
        container.add(row);

        var [x, y, z] = selected.origin.position

        var input = new UI.Input(`(${x}, ${y}, ${z})`);
        input.onChange(function () {

            let val = this.getValue().substring(1, this.getValue().length - 1)
            let position = val.split(',').map(s => parseInt(s.trim()))
            selected.origin.position[0] = position[0]
            selected.origin.position[1] = position[1]
            selected.origin.position[2] = position[2]

        });
        row.add(input);

        //Rotation of origin

        var row = new UI.Row();
        row.add(new UI.Text('Rotation of origin').setWidth('180px'));
        container.add(row);

        var [x, y, z] = selected.origin.rotation        

        var input = new UI.Input(`(${x}, ${y}, ${z})`);
        input.onChange(function () {
            let val = this.getValue().substring(1, this.getValue().length - 1)
            let rotation = val.split(',').map(s => parseInt(s.trim()))
            selected.origin.rotation[0] = rotation[0]
            selected.origin.rotation[1] = rotation[1]
            selected.origin.rotation[2] = rotation[2]

        });
        row.add(input);

        //Position of destination

        var row = new UI.Row();
        row.add(new UI.Text('Position of destination').setWidth('180px'));
        container.add(row);

        var [x, y, z] = selected.destination.position

        var input = new UI.Input(`(${x}, ${y}, ${z})`);
        input.onChange(function () {
            let val = this.getValue().substring(1, this.getValue().length - 1)
            let position = val.split(',').map(s => parseInt(s.trim()))
            selected.destination.position[0] = position[0]
            selected.destination.position[1] = position[1]
            selected.destination.position[2] = position[2]

        });
        row.add(input);

        //Rotation of destination

        var row = new UI.Row();
        row.add(new UI.Text('Rotation of destination').setWidth('180px'));
        container.add(row);

        var [x, y, z] = selected.destination.rotation

        var input = new UI.Input(`(${x}, ${y}, ${z})`);
        input.onChange(function () {
            let val = this.getValue().substring(1, this.getValue().length - 1)
            let rotation = val.split(',').map(s => parseInt(s.trim()))
            selected.destination.rotation[0] = rotation[0]
            selected.destination.rotation[1] = rotation[1]
            selected.destination.rotation[2] = rotation[2]

        });
        row.add(input);

        // Animation

        var row = new UI.Row();
        row.add(new UI.Text('Animation').setWidth('180px'));
        container.add(row);

        //AnimationSelection

        var row = new UI.Row();
        container.add(row);
        var animationVoice = new UI.Select()

        animationVoice.setOptions(editor.animationItems.map((animationItem, i) => animationItem.name)).setValue(0);
        animationVoice.onChange(function () {

            selected.voice = this.getValue();
            signals.animationRenamed.dispatch(selected);

        });

        row.add(animationVoice);

        // before commenting this code back note that the animation is applying to the entire setdesign which is not what we want -dj and yuchen

        // // Animation
        // var row = new UI.Row();
        // var button = new UI.Button('Add Animation').setWidth('100%')

        // button.onClick(function () {
        //     let addedElement = _addNewAnimationElement(selected)
        //     createAnimationEditor(container, addedElement)
        // });
        // row.add(button);
        // container.add(row);


        // selected.elements.forEach((element) => {
        //     if (element.animation) {
        //         createAnimationEditor(container, element)
        //     }
        // })

        //

        
        // let selectedSetDesign = editor.setDesignItems.find(setDesign => setDesign.name === selected.name)
        // let existingProps = selectedSetDesign.existing_props
        selected.elements.forEach(element => {
            if (element.prop) {
                createPropEditor(element, container)
            }
        })
    }

    // shows the props that belongs to the current Set desight
    function createPropEditor(element, container) {
        var row = new UI.Row();
        // selected    
        row.add(new UI.Text(element.prop.name).setWidth('90px'));        
        container.add(row)

        var row = new UI.Row();
        var img = new UI.Image(element.prop.image.imageURL);

        img.setWidth('180px')
        row.add(img)
        container.add(row)

        var row = new UI.Row();
        row.add(new UI.Text('Position of origin').setWidth('180px'));
        container.add(row);

        var [x, y, z] = element.prop.position

        var input = new UI.Input(`(${x}, ${y}, ${z})`);
        input.onChange(function () {

            let val = this.getValue().substring(1, this.getValue().length - 1)
            let position = val.split(',').map(s => parseInt(s.trim()))
            element.prop.position[0] = position[0]
            element.prop.position[1] = position[1]
            element.prop.position[2] = position[2]

        });
        row.add(input);

        var row = new UI.Row();
        row.add(new UI.Text('Rotation of origin').setWidth('180px'));
        container.add(row);

        var [x, y, z] = element.prop.rotation

        var input = new UI.Input(`(${x}, ${y}, ${z})`);
        input.onChange(function () {

            let val = this.getValue().substring(1, this.getValue().length - 1)
            let rotation = val.split(',').map(s => parseInt(s.trim()))
            element.prop.rotation[0] = rotation[0]
            element.prop.rotation[1] = rotation[1]
            element.prop.rotation[2] = rotation[2]

        });
        row.add(input);
    }

    function createAnimationEditor(container, currentElement) {

        // Select Animation
        var row = new UI.Row();
        row.add(new UI.Text('Animation ' + animationEditorIndex).setWidth('90px'));
        container.add(row);

        var row = new UI.Row();
        row.add(new UI.Text('Animation Selector').setWidth('180px'));
        container.add(row);

        var animation = new UI.Select()
        let animationIndex = editor.animationItems.findIndex(animationItem => animationItem.name === currentElement.animation.name)
        animation.setOptions(editor.animationItems.map((animationItem, i) => animationItem.name)).setValue(animationIndex);
        animation.onChange(function (e) {

            let changedAnimationSelectionIndex = this.getValue()
            let newName = editor.animationItems[parseInt(changedAnimationSelectionIndex)].name
            currentElement.animation.name = newName

        });
        row.add(animation);

        //Enter Animation Start
        var row = new UI.Row();
        row.add(new UI.Text('Animation Start').setWidth('180px'));
        container.add(row);

        var animationStart = new UI.Number(currentElement.animation.startTime).setWidth('45px');
        animationStart.onChange(function (e) {

            let animationStartTime = this.getValue();
            currentElement.animation.startTime = animationStartTime

        });
        row.add(animationStart);

        //Enter Animation End
        var row = new UI.Row();
        row.add(new UI.Text('Animation End').setWidth('180px'));
        container.add(row);

        var animationEnd = new UI.Number(currentElement.animation.endTime).setWidth('45px');
        animationEnd.onChange(function (e) {

            let animationEndTime = this.getValue();
            currentElement.animation.endTime = animationEndTime

        });
        row.add(animationEnd);

        //Animation Position of destination

        var row = new UI.Row();
        row.add(new UI.Text('Animation Position of destination').setWidth('180px'));
        container.add(row);

        var [x, y, z] = currentElement.animation.destination.position

        var input = new UI.Input(`(${x}, ${y}, ${z})`);
        input.onChange(function () {
            let val = this.getValue().substring(1, this.getValue().length - 1)
            let position = val.split(',').map(s => parseInt(s.trim()))
            currentElement.animation.destination.position[0] = position[0]
            currentElement.animation.destination.position[1] = position[1]
            currentElement.animation.destination.position[2] = position[2]

        });
        row.add(input);

        //Animation Rotation of destination

        var row = new UI.Row();
        row.add(new UI.Text('Animation Rotation of destination').setWidth('180px'));
        container.add(row);

        var [x, y, z] = currentElement.animation.destination.rotation

        var input = new UI.Input(`(${x}, ${y}, ${z})`);
        input.onChange(function () {
            let val = this.getValue().substring(1, this.getValue().length - 1)
            let rotation = val.split(',').map(s => parseInt(s.trim()))
            currentElement.animation.destination.rotation[0] = rotation[0]
            currentElement.animation.destination.rotation[1] = rotation[1]
            currentElement.animation.destination.rotation[2] = rotation[2]

        });
        row.add(input);

        // increment for new voice editor
        animationEditorIndex++
        
    }


    function _addNewAnimationElement(selected) {
        let elementToAdd = {
            animation: {
                name: editor.animationItems[defaultAnimationIndex].name,
                startTime: 0,
                endTime: 0,
                destination: {
                    position: [0, 0, 0],
                    rotation: [0, 0, 0]
                },
                elements: []
            }
        }
        selected.elements.push(elementToAdd)
        return elementToAdd
    }

    //

    // signals.editorCleared.add( function () {

    // 	selected = null;
    // 	build();

    // } );

    signals.animationSelected.add(function (animation) {
        selected = animation;
        build();            
    });

    signals.effectCompiled.add(build);

	/*
	signals.timeChanged.add( function () {

		if ( selected !== null ) {

			for ( var key in values ) {

				values[ key ].setValue( selected.module.parameters[ key ].value );

			}

		}

	} );
	*/

    return container;

};

export default SetDesignTab


//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/SetDesignTab.js
// module id = null
// module chunks = 